import { render, staticRenderFns } from "./TradingRank.vue?vue&type=template&id=ac2de360&scoped=true"
import script from "./TradingRank.vue?vue&type=script&lang=js"
export * from "./TradingRank.vue?vue&type=script&lang=js"
import style0 from "./TradingRank.vue?vue&type=style&index=0&id=ac2de360&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2de360",
  null
  
)

export default component.exports